import { Flex, FlexProps } from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useStep } from "views/admin/campaign_create/roas/components/StepContext";

interface StepContainerProps extends FlexProps {
  children: React.ReactNode[];
}

const StepContainer: React.FC<StepContainerProps> = ({ children, ...rest }) => {
  const { step: activeIndex } = useStep();
  const containerRef = useRef<HTMLDivElement>(null);
  const [childWidth, setChildWidth] = useState(0);
  const [mountedSteps, setMountedSteps] = useState<boolean[]>([]);

  useEffect(() => {
    if (containerRef.current) {
      setChildWidth(containerRef.current.offsetWidth);
    }
  }, [containerRef.current]);

  useEffect(() => {
    setMountedSteps((prev) => {
      const newMounted = [...prev];
      newMounted[activeIndex] = true;
      return newMounted;
    });
  }, [activeIndex]);

  const totalWidth = children.length * childWidth;

  const containerVariants = {
    initial: {
      x: 0,
    },
    animate: {
      x: -activeIndex * childWidth,
    },
  };

  return (
    <Flex ref={containerRef} overflow="hidden" position="relative" {...rest}>
      <Flex
        as={motion.div}
        initial="initial"
        animate="animate"
        variants={containerVariants}
        transition={"0.1s ease"}
        width={totalWidth}
      >
        {React.Children.map(children, (child, index) => (
          <Flex key={index} as={motion.div} width={childWidth} flex="none">
            {mountedSteps[index] && React.isValidElement(child)
              ? React.cloneElement(child)
              : null}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default StepContainer;
